import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronRight = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6 2.5L11.3643 7.67917C11.4513 7.76484 11.5 7.88003 11.5 8C11.5 8.11997 11.4513 8.23516 11.3643 8.32083L6 13.5",
		stroke: "currentColor",
		strokeWidth: 1.5
	})
});
export default SvgChevronRight;
